import { useContext } from "react";
import { TokenContext } from "../providers/TokenProvider";

// This will literally return the values from the provider
export const useTokens = () => {
    return useContext(TokenContext);
};
